import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AddressBookEntry } from '../models/address-book.model';
import { AddressBookSearchService } from '../../services/common/address-book-search.service';

@Component({
  selector: 'app-search-address-book-entry',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatProgressSpinnerModule, MatDialogModule, MatTableModule, FormsModule, MatProgressSpinnerModule],
  templateUrl: './search-address-book-entry.component.html',
  styleUrl: './search-address-book-entry.component.scss'
})
export class SearchAddressBookEntryComponent implements OnInit {

  displayedColumns: string[] = ['index', 'name', 'currency', 'holdPayment'];
  searchResult = new MatTableDataSource<AddressBookEntry>();
  searchString: string = '';
  isLoading: boolean = false;
  error: boolean = false;

  constructor(public dialogRef: MatDialogRef<SearchAddressBookEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private addressBookService: AddressBookSearchService) { }

  ngOnInit(): void {
    if (this.data.payableName) {
      this.searchString = this.data.payableName;
      this.search();
    }
  }
    
  search(): void {
    if (this.searchString) {
      this.isLoading = true;
      this.addressBookService.searchAddressBook(this.searchString).subscribe({
        next: (data) => {
          this.searchResult = new MatTableDataSource<AddressBookEntry>(data);
          this.isLoading = false;
        },
        error: () => {
          this.error = true;
          this.isLoading = false;
          this.searchResult = new MatTableDataSource<AddressBookEntry>(exampleData);
        }
      });
    }
  }

  selectEntry(entry: AddressBookEntry): void {
    this.dialogRef.close(entry);
  }
}

const exampleData: AddressBookEntry[] = [
  {
    name: 'John Doe',
    currency: 'USD',
    holdPayment: false,
    serialNumber: 0
  },
  {
    name: 'Jane Doe',
    currency: 'USD',
    holdPayment: true,
    serialNumber: 0
  },
  {
    name: 'John Smith',
    currency: 'EUR',
    holdPayment: false,
    serialNumber: 0
  }
]